import React, { Component } from 'react';
//import logo from './logo.svg';
//import ear from './ear_512x512.png';
//import couchcast_logo from './couchcast_logo.png';

import './Home.css';
import Broadcast from './Broadcast';

import { Link } from "react-router-dom";

import masterGameList from './mastergamelist.json';

//import axios from 'axios';

class Home extends Component {

  constructor() {
    super();
    //this.handleSubmit = this.handleSubmit.bind(this);
    this.callJquery = this.callJquery.bind(this);
   // this.callEVDB = this.callEVDB.bind(this);
   this.events = this.state.events;
  }

  callJquery(event){
    event.preventDefault();
    var inputValue = document.getElementById("inputHomeSearchBox").value;
    console.log(inputValue);
    /*
    window.$("#sample").click(function(){
      alert("Text: Button Clicked");
    });
    */

   
    var today = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    var gameData = masterGameList.filter(function (game) {
      var date = new Date(game.Date);
      return (date >= today && date <= tomorrow);
    });
    console.log(gameData);


    var dd = today.getDate();
    var mm = today.getMonth()+1; //January is 0!
    var yyyy = today.getFullYear();
    if(dd<10){
        dd='0'+dd;
    } 
    if(mm<10){
        mm='0'+mm;
    } 
    today = yyyy+mm+dd+'00';

    dd = tomorrow.getDate();
    mm = tomorrow.getMonth()+1; //January is 0!
    yyyy = tomorrow.getFullYear();
    if(dd<10){
        dd='0'+dd;
    } 
    if(mm<10){
        mm='0'+mm;
    } 
    tomorrow = yyyy+mm+dd+'00';
    console.log(today+'-'+tomorrow)
    
    /*
    var oArgs = {
      app_key: "MFCCmzMMxVpJXPfw",
      id: "20218701",
      page_size: 25,
      location: inputValue,
      keywords: inputValue,
      t: today+'-'+tomorrow
      
    };
    */

      /*window.EVDB.API.call("/events/search", oArgs, function (oData) {
        console.log(oData);
        //console.log(this);

        //this.state.events = oData.events;
        //console.log(this.state.persons);
          // Note: this relies on the custom toString() methods below
          localStorage.events = JSON.stringify(oData);

          return oData;
      });*/

      //      console.log("oData",oData);
      //      this.state.events = JSON.parse(localStorage.events.events);
      //console.log(typeof JSON.parse(localStorage.events));
      //console.log(JSON.parse(localStorage.events));
      //console.log(JSON.parse(localStorage.events).total_items);

      var string1 = []
      let listItems;
      var newData = gameData;
      if(true||(JSON.parse(localStorage.events).events !== "null"&&JSON.parse(localStorage.events).events !== null)){
       // newData = JSON.parse(localStorage.events).events.event;
        //console.log("this.events",typeof newData,newData);

        for (var property1 in newData) {
          console.log(newData[property1].Sport +  " " + newData[property1].Home_Team +  " vs " + newData[property1].Away_Team +  " " );

         // var innerLi = newData[property1].Sport +  " " + newData[property1].Home_Team +  " vs " + newData[property1].Away_Team; 
         // var goodLi = document.createElement("LI");

         //const data =[{"name":"test1"},{"name":"test2"}];
         //listItems = data.map((d) => <li key={d.name}>{d.name}</li>);
         listItems = newData.map((d) => <li key={d.key}>{d.Sport} {d.Home_Team} vs.  {d.Away_Team}</li>);
          
          //string1.push(innerLi);
  //        string1.push(newData[property1].title + '\n');
  //        this.state.events.push(JSON.stringify(newData[property1]));
        }
        //console.log(this.state.events);
        /*
        var finalArray = [];
  
        string1.forEach(element => {
          finalArray.push(JSON.parse(element));
        });
        */
  
  
  
      
       this.setState({
        events: listItems
      });      
  
      } else {
        string1.push("no matches");
        
        this.setState({
          events: string1
        });
      }

      
        
    }


  
  state = {
    date: new Date(),
    persons: [],
    events: []
  }

  /*
   callEVDB(event)  {

      var oArgs = {

          app_key: "MFCCmzMMxVpJXPfw",

          id: "20218701",

          page_size: 25,

      };

      EVDB.API.call("/events/get", oArgs, function (oData) {

          // Note: this relies on the custom toString() methods below

      });

  }
*/

/*


  handleSubmit1(event)  {

      var oArgs = {

          app_key: "MFCCmzMMxVpJXPfw",

          q: "music",

          where: "San Diego",

          "date": "2018061000-2019062000",

          page_size: 5,

          sort_order: "popularity",

      };

      EVDB.API.call("/events/search", oArgs, function (oData) {

          // Note: this relies on the custom toString() methods below

      });

  }
*/

/*
  handleSubmit(event) {
    console.log(event)
    event.preventDefault();
    //const data = new FormData(event.target);

    const data = {
      app_key: "MFCCmzMMxVpJXPfw",
      keywords:"football"
    };
    
    axios({ 
    url:`https://api.eventful.com/json/events/search`,
    method: "get",
    data: {
      location: "los angeles",
      keywords:"football" 
    },
    params : { 
      app_key: "MFCCmzMMxVpJXPfw"
    }
    })
      .then(res => {
        const persons = res.data;
        this.setState({ persons });
      })
    
    //not used at all
    fetch('https://api.eventful.com/json/events/search?...&location=Los+Angeles', {
      method: 'POST',
      data: {
        app_key: "MFCCmzMMxVpJXPfw",
        keywords:"football"
      }
    });

   const getEvents = () => {
    try {
      return axios({

        url: 'https://api.eventful.com/json/events/search?...&location=Los+Angeles',
        method: 'post',
        data: {
          app_key: "MFCCmzMMxVpJXPfw",
          keywords:"football"
        }
      });
    } catch (error) {
      console.error(error)
    }
  }

  const breeds = getEvents();
  }
  */


  data = {
    app_key: "MFCCmzMMxVpJXPfw",
    keywords:"football"
  };

  componentDidMount() {

    
    
      
  }


  render() {

    /*
    const backgroundLogo = {
      backgroundImage: './couchcast_logo.png'
    }
    */
    
    const list = {
      //listStyle: 'none',
      color: 'white',
      zIndex: '-1',
      lineHeight: '1.5',
      textAlign: 'left'
    };

    function focusedInput(e){
      
      if(e.target.value === "Search"){
        e.target.value = "";
      }
    }

    /*
    function broadcastInputHomeClickHandler(e){
      e.preventDefault();
      console.log('The broadcastInputHomeClickHandler was clicked.');
      return(<Broadcast />);
    }
    function listenInputHomeClickHandler(e){
      e.preventDefault();
      console.log('The listenInputHomeClickHandler was clicked.');
    }
    */
    
    function searchBoxChanged(e){
      //e.preventDefault();
      var newvalue = e.target.value.toString();
      console.log('The search now says: ',newvalue);
      //document.getElementById("inputBroadcastSearchBox").value = newvalue;
    }

/*
    function queryEventful(e){
      const getEvents = () => {
        try {
          return axios({
//            url: 'https://api.eventful.com/json/events/search?...&location=Los+Angeles' + id_token,
            url: 'https://api.eventful.com/json/events/search?...&location=Los+Angeles',
            method: 'get',
            data: {
              app_key: "MFCCmzMMxVpJXPfw",
              keywords:"football"
            }
          });
        } catch (error) {
          console.error(error)
        }
      }

      const breeds = getEvents();
    }
*/


    return (
      <div className="Home">
        <header className="Home-header">
          <form onSubmit={this.callJquery} >
              <input id="inputHomeSearchBox" className="Home-searchBox" onFocus={focusedInput} onChange={searchBoxChanged} defaultValue="Search"></input>
              
          </form>
          <h1 className="Home-title">Any game or live tv event on...</h1>
          <h1 className="Home-title">{this.state.date.toLocaleDateString()}</h1>
          </header>
          <ul  style={list}>
            { 
              this.state.events 
            }
          </ul>  
          
        <article>
        </article>
        <p className="Home-intro">
          
        </p>
        <footer className="footer-home">
          <div className="Home-footer-home">
            <Link to={`/Broadcast/`} className="btn-footer-home">Broadcast</Link>
            <Link to={`/Listen/`} className="btn-footer-home">Listen</Link>
          </div>

                    
          <Link to={`/`} className="btn-footer-home back-btn" >Logout</Link>
        </footer>
      </div>
    ); 
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js